import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import { AiOutlineSearch } from "react-icons/ai";
import axioPath from 'api/axioPath';
import { showAppLoader, hideAppLoader } from 'redux/actions/app'
import Spinner from "web/components/Spinner"
import AlertModal from "web/components/AlertModal";
import { Header, TableWrapper, TableSection, SearchWrapper } from '../../DashBoard/dashBoardStyled'
//table
import { Table } from 'reactstrap';
import CsvDownloader from 'react-csv-downloader';
import { MdKeyboardBackspace } from "react-icons/md";
import Pagination from '@material-ui/lab/Pagination';
import CommissionReportList from './CommissionReportList'
import moment from 'moment';

function CommissionReport() {
  let history = useHistory();
  let location = useLocation();
  const dispatch = useDispatch();

  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const toggleModal = () => setModal(!modal);


  const loaderVisible = useSelector(state => state.appReducer.loaderVisible);
  const [dataList, setDataList] = useState([]);
  const [finalData, setFinalData] = useState([])
  const [csvData, setCsvData] = useState([])
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [tableSearch, setTableSearch] = useState('')
  const [activePage, setActivePage] = useState('CommissionReport')
  const [headerArr, setHeaderArr] = useState([
    { title: 'Contact Name', },
    { title: 'Company Name', },
    { title: 'Email', },
    { title: 'Earning', },
    { title: 'Quantity', },
    { title: 'Commission Type', },
    { title: 'Commission Value', },
    { title: 'Order ID', },
    { title: 'Order Type', },
    { title: 'Start Date', },
    { title: 'Product Price', },
    // { title: 'Buyer Fee Amount', },
    { title: 'Status', },
  ])
  const [referredUsersList, setReferredUsersList] = useState([])

  //for csv download
  const [columns, setColumns] = useState([
    { id: 'CommissionType', displayName: 'Commission Type' },
    { id: 'ContactName', displayName: 'Contact Name' },
    { id: 'Email', displayName: 'Email' },
    { id: 'CompanyNameRole', displayName: 'Company Name/Role' },
    { id: 'PayableTo', displayName: 'Payable To' },
    { id: 'Buyer', displayName: 'Buyer' },
    { id: 'Seller', displayName: 'Seller' },
    { id: 'YesNo', displayName: 'One time payment (Yes/No)' },
    { id: 'OD', displayName: 'OD#' },
    { id: 'OrderCreationDate', displayName: 'Order Creation Date' },
    { id: 'ActualDeliveryDate', displayName: 'Actual Delivery Date' },
    { id: 'ReceiptNumber', displayName: 'Receipt Number' },
    { id: 'PaymentInititation', displayName: 'Payment Inititation' },
    { id: 'OrderQty', displayName: 'Order Qty' },
    { id: 'UnitPrice', displayName: 'Unit Price' },
    { id: 'ExtendedAmount', displayName: 'Extended Amount' },
    { id: 'CommissionType2', displayName: 'Comm Type' },
    { id: 'OrderType', displayName: 'Order Type' },
    { id: 'CommissionRate', displayName: 'Comm Rate' },
    { id: 'Multiplier', displayName: 'Multiplier' },
    { id: 'CommissionPayable', displayName: 'Commission Payable' },
    { id: 'BuyerFeeOrderLevel', displayName: 'Buyer Fee Order Level' },
    { id: 'TotalFeeAmountOrderLevel', displayName: 'Total Fee Amount Order Level' },
    { id: 'AffliateReferralFeePercent', displayName: 'Affliate Referral Fee %' },
    { id: 'AffliateReferralMultipier', displayName: 'Affliate Referral Multipier' },
    { id: 'GrossAffiliateFeePayable', displayName: 'Gross Affiliate Fee Payable' },
    { id: 'PaidDate', displayName: 'Paid Date' },
    { id: 'CommissionMonth', displayName: 'Commission Month' },
    { id: 'PayDate', displayName: 'Pay Date' },
  ])

  useEffect(() => {
    if (location.state !== null && location.state !== undefined) {

      let tempData = location.state.data
      let filters = location.state.filters

      //set csv data
      if (tempData !== null) {
        ExportFunction()
        let pageData = JSON.parse(JSON.stringify(tempData?.list))
        setFinalData(pageData)
        setPageCount(location.state.data?.totalPages)
      }
      // csvfunction(tempData?.list)
      // let tempCsvData = tempData.map(val => {
      //     return ({
      //         ReferralCode: val.referralCode,
      //         Username: val.username?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r"," "),
      //         Email: val.emailId,
      //         Period: `${val.month} ${val.year}`,
      //         ReferralCount: val.referralCount
      //     })
      // })
      // setCsvData(tempCsvData)

      // if (tempData !== null) setDataList(tempData?.list)
      // //pagination
      // let pageData = JSON.parse(JSON.stringify(tempData?.list))
      // setFinalData(pageData)
      // setPageCount(location.state.data?.totalPages)

      // setFinalData(pageData.splice(page * 10 - 10, 10))
      // if (tempData?.list.length % 10 === 0) {
      //     setPageCount(tempData?.list.length / 10)
      //     //setPageCount(tempData?.totalPages)
      // } else {
      //     //setPageCount(tempData?.totalPages)
      //     setPageCount(Math.trunc(tempData?.list.length / 10) + 1)
      // }
    }
  }, []);

  function getThirdWednesdayOfMonth(date) {
    const inputDate = moment(date, 'MM-DD-YYYY');
    const year = inputDate.year();
    const month = inputDate.month();

    const firstDayOfMonth = moment([year, month]);
    const firstDayOfWeek = firstDayOfMonth.day();
    const daysUntilFirstWednesday = (3 - firstDayOfWeek + 7) % 7;
    const daysUntilThirdWednesday = daysUntilFirstWednesday + 14;
    const thirdWednesday = firstDayOfMonth.clone().add(daysUntilThirdWednesday, 'days');

    return thirdWednesday;
  }

  const csvfunction = (getData) => {
    let tempCsvData = getData.map(val => {

      // parameters for rate and multiplier is same for internal and affiliate type
      // only the gross calcualtion is differnet
      // for internal (multiplier * product price)
      // for affilaite (multiplier * buyer fee)
      let commissionRateValue, commissionRateMultiplier, commissionPayableValue, grossAffiliateFeePayableValue
      if (val.commissionMode === 'PERCENTAGE') {
        commissionRateValue = val.commissionModeValue?.toFixed(3) + '%'
        commissionRateMultiplier = (val.commissionModeValue / 100)?.toFixed(5)
        commissionPayableValue = '$ ' + (val?.productPrice * (val.commissionModeValue / 100))?.toFixed(2)
        grossAffiliateFeePayableValue = '$ ' + (val?.buyerFeeAmount * commissionRateMultiplier)?.toFixed(2)
      } else if (val.commissionMode === 'FLAT') {
        commissionRateValue = '$ ' + val.commissionModeValue?.toFixed(2)
        commissionPayableValue = '$ ' + val.commissionModeValue?.toFixed(2)
        grossAffiliateFeePayableValue = '$ ' + val.commissionModeValue?.toFixed(2)
      }
      let tempPaidDate, nextThirdWednesday
      if (val?.ordDetailResponse?.paymentInititatedDate) {
        tempPaidDate = moment(val?.ordDetailResponse?.paymentInititatedDate * 1000).format('MM-DD-YYYY')
      }
      if (tempPaidDate) {
        let currentMonthThirdWednesday = getThirdWednesdayOfMonth(tempPaidDate);
        if (moment(tempPaidDate).isBefore(moment(currentMonthThirdWednesday))) {
          nextThirdWednesday = currentMonthThirdWednesday.format('MM-DD-YYYY')
        } else {
          let firstDayOfNextMonth = moment(tempPaidDate).clone().add(1, 'month').startOf('month');
          let formattedDate = firstDayOfNextMonth.format('MM-DD-YYYY');
          let nextMonthThirdWed = getThirdWednesdayOfMonth(formattedDate);
          nextThirdWednesday = nextMonthThirdWed.format('MM-DD-YYYY')
        }
      }

      return ({
        CommissionType: val.commissionType,
        ContactName: val.name?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),
        Email: val.email,
        CompanyNameRole: val.commissionType == 'AFFILIATE' ? val.companyName?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " ") : val.userRole,
        PayableTo: val.commissionType == 'AFFILIATE' ? val.companyName?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " ") : val.name?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),
        Buyer: val?.ordDetailResponse?.buyerLocationName?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " ") || '',
        Seller: val?.ordDetailResponse?.sellerLocationName?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " ") || '',
        YesNo: val.commissionOrderType === 'One Time' ? 'Yes' : 'No',
        OD: val.orderId,
        OrderCreationDate: val?.ordDetailResponse?.orderCreationDate ? moment(val?.ordDetailResponse?.orderCreationDate * 1000).format('MM-DD-YYYY') : '',
        ActualDeliveryDate: val?.ordDetailResponse?.actualDeliveryDate ? moment(val?.ordDetailResponse?.actualDeliveryDate).format('MM-DD-YYYY') : '',
        ReceiptNumber: val?.ordDetailResponse?.buyerInvoiceId,
        PaymentInititation: val?.ordDetailResponse?.paymentInititatedDate ? moment(val?.ordDetailResponse?.paymentInititatedDate * 1000).format('MM-DD-YYYY') : '',
        OrderQty: val.quantity,
        UnitPrice: val?.ordDetailResponse?.unitPrice ? "$ " + parseFloat(val?.ordDetailResponse?.unitPrice).toFixed(2) : '',
        ExtendedAmount: val?.productPrice ? "$ " + parseFloat(val?.productPrice).toFixed(2) : '',
        CommissionType2: val.commissionMode,
        OrderType: val.commissionOrderType,
        CommissionRate: val.commissionType === 'INTERNAL' ? commissionRateValue : 'NA',
        Multiplier: (val.commissionType === 'INTERNAL' && val.commissionMode === 'PERCENTAGE') ? commissionRateMultiplier : 'NA',
        CommissionPayable: val.commissionType === 'INTERNAL' ? commissionPayableValue : 'NA',
        BuyerFeeOrderLevel: val.commissionType === 'AFFILIATE' ? `$ ${val.buyerFeeAmount}` : 'NA',
        TotalFeeAmountOrderLevel: val.totalBuyerFee ? `$ ${val.totalBuyerFee?.toFixed(2)}` : 'NA',
        AffliateReferralFeePercent: val.commissionType === 'AFFILIATE' ? commissionRateValue : 'NA',
        AffliateReferralMultipier: (val.commissionType === 'AFFILIATE' && val.commissionMode === 'PERCENTAGE') ? commissionRateMultiplier : 'NA',
        GrossAffiliateFeePayable: val.commissionType === 'AFFILIATE' ? grossAffiliateFeePayableValue : 'NA',
        PaidDate: val?.ordDetailResponse?.paymentInititatedDate ? moment(val?.ordDetailResponse?.paymentInititatedDate * 1000).format('MM-DD-YYYY') : '',
        CommissionMonth: val?.ordDetailResponse?.paymentInititatedDate ? moment(val?.ordDetailResponse?.paymentInititatedDate * 1000).format('MMM-YYYY') : '',
        PayDate: nextThirdWednesday
      })
    })
    setCsvData(tempCsvData)
  }

  const handleChange = (event, value) => {
    setPage(value);
    commissiomExportApi(value - 1)
    // const search = tableSearch
    // let dataListtemp = dataList.filter(value => {
    //     return (
    //         value.name.toString().toLowerCase().includes(search.toLowerCase()) ||
    //         value.companyName.toString().toLowerCase().includes(search.toLowerCase()) ||
    //         value.email.toString().toLowerCase().includes(search.toLowerCase()) ||
    //         value.commissionAmount.toString().toLowerCase().includes(search.toLowerCase()) ||
    //         value.earning.toString().toLowerCase().includes(search.toLowerCase()) ||
    //         value.commissionMode.toString().toLowerCase().includes(search.toLowerCase()) ||
    //         value.commissionType.toString().toLowerCase().includes(search.toLowerCase()) ||
    //         value.commissionAmount.toString().toLowerCase().includes(search.toLowerCase()) ||
    //         value.orderId.toString().toLowerCase().includes(search.toLowerCase()) ||
    //         value.commissionOrderType.toString().toLowerCase().includes(search.toLowerCase()) ||
    //         value.StartDate.toString().toLowerCase().includes(search.toLowerCase()) ||
    //         value.buyerFeeAmount.toString().toLowerCase().includes(search.toLowerCase()) ||
    //         value.Status.toString().toLowerCase().includes(search.toLowerCase())
    //     )
    // }
    // );
    // let pageData = JSON.parse(JSON.stringify(dataListtemp))
    // setFinalData(pageData.splice(value * 10 - 10, 10))
  };

  const ExportFunction = () => {
    dispatch(showAppLoader());
    // if(dateSelect){
    let data = {
      commissionType: location.state?.dataObj?.commissionType,
      locationId: location.state?.dataObj?.locationId,
      userId: location.state?.dataObj?.userId,
      startDate: location.state?.dataObj?.startDate,
      endDate: location.state?.dataObj?.endDate,
    }
    const token = localStorage.getItem("token")
    let url = 'user/commission/export_commission_transaction'
    axioPath.post(url, data, {
      headers: {
        Authorization: token,
      },
    }).then((response) => {
      dispatch(hideAppLoader());
      if (response.data.status === 'SUCCESS') {
        if (response.data.payload) {
          let userSubList = response.data.payload
          if (userSubList.length === 0) {
            setModalContent("No records found")
            setModal(!modal)
          } else {

            csvfunction(userSubList?.list)

          }
        }
      } else {
        if (response.data.message === "Unauthorized (Invalid token)") {
          history.push('/sign-in')
          window.location.reload(false);
        } else {
          setModalContent(response.data.message)
          setModal(!modal)
        }
      }
    }).catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response?.status === 401) {
        history.push('./sign-in')
        window.location.reload(false)
      } else {
        setModalContent(ex.message)
        setModal(!modal)
      }
    });
  }


  const commissiomExportApi = (pageCount, search) => {
    dispatch(showAppLoader());
    // if(dateSelect){
    let data = {
      commissionType: location.state?.dataObj?.commissionType,
      locationId: location.state?.dataObj?.locationId,
      userId: location.state?.dataObj?.userId,
      startDate: location.state?.dataObj?.startDate,
      endDate: location.state?.dataObj?.endDate,
      size: 10,
      searchBy: search || '',
      number: pageCount,
      sort: "DESC"
    }

    const token = localStorage.getItem("token")
    let url = 'user/commission/get_commission_transaction'
    axioPath.post(url, data, {
      headers: {
        Authorization: token,
      },
    }).then((response) => {
      dispatch(hideAppLoader());
      if (response.data.status === 'SUCCESS') {
        if (response.data.payload) {
          let userSubList = response.data.payload
          if (userSubList.length === 0) {
            setModalContent("No records found")
            setModal(!modal)
          } else {
            setDataList(userSubList?.list)
            let pageData = JSON.parse(JSON.stringify(userSubList?.list))
            setFinalData(pageData)

            setPageCount(userSubList?.totalPages)
          }
        }
      } else {
        if (response?.data?.message === "Unauthorized (Invalid token)") {
          history.push('/sign-in')
          window.location.reload(false);
        } else {
          if (response?.data?.message === "No Record found.") {
            setFinalData([])
          } else {
            setModalContent(response?.data?.message)
            setModal(!modal)
          }

        }
      }
    }).catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response?.status === 401) {
        history.push('./sign-in')
        window.location.reload(false)
      } else {
        setModalContent(ex.message)
        setModal(!modal)
      }
    });
  };
  const handleSearchChange = e => {
    e.preventDefault()
    setTableSearch(e.target.value)
    const search = e.target.value
    setPage(1);
    commissiomExportApi(0, search)
    // let dataListtemp = dataList.filter(value => {
    //   return (
    //     value?.name?.toString().toLowerCase().includes(search.toLowerCase()) ||
    //     value?.companyName?.toString().toLowerCase().includes(search.toLowerCase()) ||
    //     value?.email?.toString().toLowerCase().includes(search.toLowerCase()) ||
    //     value.commissionAmount?.toString().toLowerCase().includes(search.toLowerCase()) ||
    //     value.earning?.toString().toLowerCase().includes(search.toLowerCase()) ||
    //     value.quantity?.toString().toLowerCase().includes(search.toLowerCase()) ||
    //     value.commissionMode?.toString().toLowerCase().includes(search.toLowerCase()) ||
    //     value?.commissionType?.toString().toLowerCase().includes(search.toLowerCase()) ||
    //     value?.commissionAmount?.toString().toLowerCase().includes(search.toLowerCase()) ||
    //     value.orderId?.toString().toLowerCase().includes(search.toLowerCase()) ||
    //     value?.commissionOrderType?.toString().toLowerCase().includes(search.toLowerCase()) ||
    //     value?.StartDate?.toString().toLowerCase().includes(search.toLowerCase()) ||
    //     value?.buyerFeeAmount?.toString().toLowerCase().includes(search.toLowerCase()) ||
    //     value?.Status?.toString().toLowerCase().includes(search.toLowerCase())
    //   )
    // }
    // );
    // csvfunction(dataListtemp)
    // setPage(page)
    // setFinalData(dataListtemp)
    // setPageCount(location.state.data?.totalPages)
    // if (dataListtemp.length % 10 === 0) {
    //     setPageCount(dataListtemp.length / 10)
    // } else {
    //     setPageCount(Math.trunc(dataListtemp.length / 10) + 1)
    // }
    // setFinalData(dataListtemp.splice(0, 10))
  }

  const handleCountClick = (e, index) => {
    e.preventDefault()
    setReferredUsersList(finalData[index].listOfUsers)
    setActivePage('ListPage')
  }

  const updateActivePageFunction = (page) => {
    setActivePage(page)
  }

  return (
    <TableWrapper>
      {activePage === 'CommissionReport' ?
        <>
          {loaderVisible && <Spinner />}
          <MdKeyboardBackspace style={{ width: '28px', height: '28px', position: 'relative', left: '12px', top: '8px', cursor: 'pointer' }}
            onClick={() => {
              history.push({
                pathname: '/reports',
                state: { page: 'commissionType' }
              })
            }} />
          <Header>
            <h3>Commission Report </h3>
            <div className='header-search-wrapper-reports'>
              <SearchWrapper>
                <input style={{ border: '1px solid #87CDF1', borderRadius: '5px' }} type="text" placeholder='Search' value={tableSearch}
                  onChange={handleSearchChange} />
                <AiOutlineSearch />
              </SearchWrapper>
              <CsvDownloader
                filename="Commission Report"
                columns={columns}
                datas={csvData}>
                <button
                  style={{ background: '#27911b', color: 'white', border: 0, borderRadius: '5px', padding: '5px 15px', margin: '5px' }}>
                  Export
                </button>
              </CsvDownloader>
            </div>
          </Header>
          <TableSection>
            <Table responsive>
              <thead>
                <tr>
                  {headerArr.map((items, index) => (
                    <th key={index}>{items.title}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {finalData && finalData.length !== 0 ? finalData.map((items, index) => (
                  <tr key={index}>
                    <td>{items?.name}</td>
                    <td>{items?.companyName}</td>
                    <td>{items?.email}</td>
                    <td>{"$" + parseFloat(items?.earning).toFixed(2)}</td>
                    <td>{items?.quantity ? items?.quantity : 'NA'}</td>
                    <td>{items?.commissionType === "AFFILIATE" ? "Affiliate" : "Internal"}</td>
                    <td>{items?.commissionMode === "PERCENTAGE" ? parseFloat(items?.commissionModeValue).toFixed(3) + "%" : "$" + parseFloat(items?.commissionModeValue).toFixed(2)}</td>
                    <td>{items?.orderId}</td>
                    <td>{items?.commissionOrderType}</td>
                    <td>{items?.createdAt}</td>
                    <td>${items?.productPrice && parseFloat(items?.productPrice).toFixed(2)}</td>
                    {/* <td>${items?.buyerFeeAmount}</td> */}
                    <td>{items?.status}</td>
                  </tr>
                )) : <p style={{ position: 'absolute', width: '100%', textAlign: 'center', marginTop: '30px' }}>No records found</p>}

              </tbody>
            </Table>
          </TableSection>
          {finalData.length !== 0 && <Pagination count={pageCount}
            page={page}
            onChange={handleChange} />}
        </>
        :
        <CommissionReportList tableData={referredUsersList} updateActivePageFunction={updateActivePageFunction} />
      }

      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        title=''
        content={modalContent}
      />
    </TableWrapper>

  )
};

export default CommissionReport;